import React, {useState} from 'react';
import {Card, Col, Form, Row} from "react-bootstrap";
import {selectDateFormat, selectLang, Translate} from "../../../../../app/store/reducers/main/mainReducer";
import {useSelector} from "react-redux";
import {Controller, useFormContext, useWatch} from "react-hook-form";
import DatePicker from "react-datepicker";
import classNames from "classnames";
import FindPerson from "../../../person/FindPerson";
import PropTypes from "prop-types";
import RoamingInvoiceEmpowermentSelector from "./RoamingInvoiceEmpowermentSelector";
import {ExecutorAccepted} from "../../../../../enum/EmpowermentStatus";
import dayjs from "dayjs";

const RoamingInvoiceFormCardEmpowermentInfo = ({isEditOrCopy}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const dateFormat = useSelector(selectDateFormat);
    const form = useFormContext();
    const [eventCount, setEventCount] = useState(0);
    const executorInn = useWatch({name: `seller.innOrPinfl`});
    const customerInn = useWatch({name: `buyer.innOrPinfl`});
    const contractDoc = useWatch({name: `contractDoc`});

    const onChangePerson = (personInfo) => {
        // if is copy or edit, prevent from conflict of values
        {
            if (isEditOrCopy && eventCount === 0) {
                setEventCount(eventCount + 1);
                return;
            }
        }

        if (personInfo) {
            form.setValue(`facturaEmpowermentDoc.agentPinfl`, personInfo.pinfl || personInfo.inn);
            form.setValue(`facturaEmpowermentDoc.agentFio`, personInfo.name);
        } else {
            form.setValue(`facturaEmpowermentDoc.agentPinfl`, '');
            form.setValue(`facturaEmpowermentDoc.agentFio`, '');
        }
    };

    const onSelectEmpowerment = (empowerment) => {
        if (empowerment) {
            form.setValue(`facturaEmpowermentDoc`, {
                empowermentNo: empowerment.info.number,
                empowermentDateOfIssue: dayjs(empowerment.info.start).toDate(),
                agentPinfl: empowerment.person_info.person_inn,
                agentFio: empowerment.person_info.full_name,
            })
        } else {
            form.setValue(`facturaEmpowermentDoc`, {
                empowermentNo: '',
                empowermentDateOfIssue: null,
                agentPinfl: '',
                agentFio: '',
            })
        }
    };

    return (
        <Card className="h-100">
            <Card.Body>
                <Form.Group as={Row} className="mb-2">
                    <Form.Label column sm="4" md="12" lg="4">{t(lang, "roaming.common.empowerment_search")}</Form.Label>
                    <Col sm={8} md={12} lg={8}>
                        <RoamingInvoiceEmpowermentSelector onChange={onSelectEmpowerment}
                                                           filter={{
                                                               status: ExecutorAccepted,
                                                               executor_inn: executorInn,
                                                               customer_inn: customerInn,
                                                               contract_number: contractDoc.contractNo,
                                                               contract_date: contractDoc.contractDate ? dayjs(contractDoc.contractDate).format("YYYY-MM-DD") : null,
                                                           }}
                        />
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-2">
                    <Form.Label column sm="4" md="12" lg="4">
                        {t(lang, 'roaming.invoice.empowerment_person.pinfl')}
                        <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm={8} md={12} lg={8}>
                        <Controller name={`facturaEmpowermentDoc.agentPinfl`}
                                    render={({field}) => (
                                        <FindPerson defaultInnOrPinfl={field.value}
                                                    onChange={onChangePerson}
                                                    placeholder={t(lang, 'roaming.invoice.empowerment_person.pinfl.placeholder')}
                                        />
                                    )}
                        />
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-2">
                    <Form.Label column sm="4" md="12" lg="4">
                        {t(lang, 'roaming.invoice.empowerment_person.name')}
                        <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm={8} md={12} lg={8}>
                        <Form.Control name={`facturaEmpowermentDoc.agentFio`}
                                      placeholder={t(lang, 'roaming.invoice.empowerment_person.name.placeholder')}
                                      isInvalid={form.formState.errors?.facturaEmpowermentDoc?.agentFio}
                                      {...form.register(`facturaEmpowermentDoc.agentFio`, {
                                          required: {
                                              value: !!form.getValues(`facturaEmpowermentDoc.agentPinfl`),
                                              message: t(lang, 'items.common.validations.is_required')
                                          }
                                      })}
                        />
                        <Form.Control.Feedback
                            type="invalid">{form.formState.errors?.facturaEmpowermentDoc?.agentFio?.message}</Form.Control.Feedback>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-2">
                    <Form.Label column sm="4" md="12" lg="4">
                        {t(lang, 'roaming.common.empowerment.number')}
                        <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm={8} md={12} lg={8}>
                        <Form.Control name={`facturaEmpowermentDoc.empowermentNo`}
                                      isInvalid={form.formState.errors?.facturaEmpowermentDoc?.empowermentNo}
                                      placeholder={t(lang, 'roaming.common.empowerment.number.placeholder')}
                                      {...form.register(`facturaEmpowermentDoc.empowermentNo`, {
                                          required: {
                                              value: !!form.getValues(`facturaEmpowermentDoc.agentPinfl`),
                                              message: t(lang, 'items.common.validations.is_required')
                                          }
                                      })}
                        />
                        <Form.Control.Feedback
                            type="invalid">{form.formState.errors?.facturaEmpowermentDoc?.empowermentNo?.message}</Form.Control.Feedback>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-2">
                    <Form.Label column sm="4" md="12" lg="4">
                        {t(lang, 'roaming.common.empowerment.date')}
                        <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm={8} md={12} lg={8}>
                        <Controller name={`facturaEmpowermentDoc.empowermentDateOfIssue`}
                                    rules={{
                                        required: {
                                            value: !!form.getValues(`facturaEmpowermentDoc.agentPinfl`),
                                            message: t(lang, 'items.common.validations.is_required')
                                        }
                                    }}
                                    render={({field, fieldState: {error}}) => (
                                        <DatePicker selected={field.value}
                                                    onChange={field.onChange}
                                                    placeholderText={t(lang, "roaming.common.empowerment.start_date.placeholder")}
                                                    dateFormat={dateFormat}
                                                    isClearable
                                                    className={classNames('form-control', {
                                                        'is-invalid': !!error?.message,
                                                    })}
                                                    wrapperClassName={classNames({
                                                        'is-invalid': !!error?.message
                                                    })}
                                        />
                                    )}
                        />
                        <Form.Control.Feedback type="invalid">{form.formState.errors?.facturaEmpowermentDoc?.empowermentDateOfIssue?.message}</Form.Control.Feedback>
                    </Col>
                </Form.Group>
            </Card.Body>
        </Card>
    );
};

export default RoamingInvoiceFormCardEmpowermentInfo;

RoamingInvoiceFormCardEmpowermentInfo.propTypes = {
    isEditOrCopy: PropTypes.bool
}

RoamingInvoiceFormCardEmpowermentInfo.defaultProps = {
    isEditOrCopy: false
}